/*!
=========================================================
* リスト型ViewのBase
=========================================================
*/
import React, {createRef, useState} from "react";
import { usePagination } from "react-table";

import {
    Card, CardHeader, CardBody,
    Row, Col,
    FormGroup
} from "reactstrap";

import Request from '../../common/Request';
import ButtonWithTooltip from '../FormParts/ButtonWithTooltip';
import TitleWithBadge from '../FormParts/TitleWithBadge';
//import CustomTable from '../ViewParts/CustomTable';
import CustomTable from '../ViewParts/OriginalTable';

export default class ListBase extends React.Component {
    default_column = [];
    constructor(props) {
        super(props);

        this.state = {
            title: '',
            add_url: undefined,
            search_url: '/',
            data: [],
            column: this.default_column,
            tmp_set: false,
            tmp_cnt: 0,
            with_all_check: false,
            detail_search: false,
            default_search: true,
            header_md:"6",
            show_detail_search_field: true,
            badge: true,
            defaultSortedColumn:[],
            checkbox_field_in_table:false,
            data_count : 0,
            auto_scroll:true ,
            unique_key: this.props.unique_key? this.props.unique_key: "",
            checkedItems: this.props.checkedItems? this.props.checkedItems: [],
            all_check_status: false,
            paging : {
                "index":0,
                "limit":50
            }
        };
        this.searchWithPageIndex = this.searchWithPageIndex.bind(this)
        this.changeForLimit = this.changeForLimit.bind(this)
        this.search_for_pager = this.search_for_pager.bind(this)

        /* 2021/07/15 scroll to list top */
        this.pageChangeHandle = this.pageChangeHandle.bind(this);
        this.checkedForItem = this.checkedForItem.bind(this);
        this.reloadBaseData = this.reloadBaseData.bind(this);
        this.addCheckedItems = this.addCheckedItems.bind(this);
        this.removeCheckedItems = this.removeCheckedItems.bind(this);
        this.allStateClear = this.allStateClear.bind(this);
    }
    pageChangeHandle( customTable ){
        window.scrollTo(0,customTable.currentRef.current.offsetTop);
        return ;
    }

    searchWithPageIndex(pageIndex = 0){
        this.setState({
            pageIndex,
            page:{"index":pageIndex}
        })
        this.search()
    }

    dataMap(data) {
        return null;
    }

    validate() {
        return false;
    }

    search_params() {
        return {};
    }

    // 検索
    search() {
        /* ここは開発者が記述 */
        if (!this.validate()) {
            // do nothing
            return;
        }

        this.search_count();

        // ＃1168　1000件対応
        var search_param = this.search_params();
        search_param["pager_limit"] = this.state.paging["limit"];
        search_param["pager_index"] = this.state.paging["index"];

        Request.get(this.state.search_url, search_param, res => {
            this.reloadBaseData(res.data);
/*
            this.setState({
                data: this.dataMap(res.data)
            });
*/
        })
    }
    search_for_pager (pager) {
//        this.setState({paging:pager});
        // ＃1168　1000件対応
        var search_param = this.search_params();
        search_param["pager_limit"] = pager["limit"];
        search_param["pager_index"] = pager["index"];

        Request.get(this.state.search_url, search_param, res => {
            this.reloadBaseData(res.data,pager);
/*            
            this.setState({
                data: this.dataMap(res.data)
            });
*/
        })
    }

    search_field_cols() {
        return (
            <>
            </>
        );
    }
    add_field_cols(){
        return (
            <>
            </>
        );
    }
    detail_search_field_btn(){
        return (<></>);
    }
    detail_search_field_cols(){
        return (<></>);
    }
    checkbox_field_cols(){
        return (<></>);
    }
    action_cols() {
        return (
            <>
            </>
        );
    }
    dialog_defines() {
        return (
            <>
            </>
        );
    }
    message_field_cols(){
        return (
            <>
            </>
        )
    }
    reloaded(){}
    paging ( pager ) {
        // ＃1168　1000件対応
        var search_param = this.search_params();
        search_param["pager_limit"] = pager["limit"];
        search_param["pager_index"] = pager["index"];

        Request.get(this.state.search_url, search_param, res => {
/*
            console.log(this.state.checkedItems,res.data);

            if (this.state.checkedItems.length>0) {
                let data = res.data.map((element) => {
                    var unique_id, checked_item;
                    switch ( this.state.unique_key ) {
                        case "INVOICE__estimate_natural_id":{
                            unique_id = element[this.state.unique_key].props.children;
                            checked_item = this.state.checkedItems.find( item2 => item2[this.state.unique_key].props.children == unique_id );
                        }break;
                        case "estimate_natural_id_ssv":
                        case "SECURITY_DEPOSIT__estimate_natural_id":{
                            unique_id = element[this.state.unique_key];
                            checked_item = this.state.checkedItems.find( item2 => item2[this.state.unique_key] == unique_id );
                        }break;
                    }
                    if ( checked_item != undefined ) {
                        element.checked = true;
                    }
                    return element;
                });
                this.setState({
                    data: this.dataMap(data),
                    paging:pager
                });
            } else {
                this.setState({
                    data: this.dataMap(res.data),
                    paging:pager
                });
            }
            */
            this.reloadBaseData(res.data,pager);
        })
    }
    changeForLimit ( limit ) {
        this.search_for_pager({"limit":limit, "index":0});
    }

    // #1168　ページング処理におけるチェックボックス対応
    checkedForItem (item) 
    {
        var checked_item, item_key, pref_key="";
        if ( this.state.unique_key.match("__") ) {
            let keys = this.state.unique_key.split("__");
            pref_key = keys[0];
            item_key = keys[1];
        }
        else {
            item_key = this.state.unique_key
        }
//        console.log(this.state.unique_key,pref_key,item_key,item,this.state.checkedItems);
        switch (pref_key) {
            case"INVOICE":{
                checked_item = this.state.checkedItems.find( item2 => item2[this.state.unique_key].props.children == item[item_key] );
            }break
            case"SECURITY_DEPOSIT": {
                checked_item = this.state.checkedItems.find( item2 => item2[this.state.unique_key] == item[item_key] );
            }break;
            default: {
                checked_item = this.state.checkedItems.find( item2 => item2[item_key] == item[item_key] );
            }break;
        }
        return (checked_item != undefined)? true: false;
    }

    // #1168 チェックボックス確認用データ更新処理
    reloadBaseData (baseData,　pager=this.state.paging) {

        let conv_data = this.dataMap(baseData);
        var all_checked = true;
        conv_data.map(d=>{
            if ( d.checked==undefined ) {
                all_checked = false;
            }
        })

//        console.log(conv_data);
        this.setState({
            data: conv_data,
            paging:pager,
            all_check_status: all_checked
        }, () => {this.reloaded();});
//        console.log("list base >> all_checked",all_checked);
//        console.log("reloaded",this.state.all_check_status);
    }

    addCheckedItems ( data, pref_key, item_key ) {
        var unique_key = this.state.unique_key;
        var unduplicate_data = [];
        for (var i in data) {
            var _data = data[i];
            var _duplicate;
            switch (pref_key) {
                case"INVOICE":{
                    _duplicate = this.state.checkedItems.find(_items=>_items[unique_key].props.children == _data[unique_key].props.children);
                }break;
                case"ACCOUNTS_RECEIVABLE":
                case"SECURITY_DEPOSIT":{
                    _duplicate = this.state.checkedItems.find(_items=>_items[unique_key] == _data[unique_key]);
                }break;
                default: {
                    _duplicate = this.state.checkedItems.find(_items=>_items[item_key] == _data[item_key]);
                }break;
            }
            if (_duplicate == undefined) unduplicate_data.push(_data);
        }
        this.setState({checkedItems:this.state.checkedItems.concat(unduplicate_data)},()=>console.log(this.state.checkedItems));
    }

    removeCheckedItems ( data, pref_key, item_key ) {
        var pref_key, unique_key = this.state.unique_key, newItems = [];
//        console.log(this.state.checkedItems,data);

        for (var i in this.state.checkedItems) {
            var res_find;
            var item = this.state.checkedItems[i];
            switch (pref_key) {
                case"INVOICE":{
                    res_find = data.find(_data=>_data[unique_key].props.children == item[unique_key].props.children);
                }break;
                case"ACCOUNTS_RECEIVABLE":
                case"SECURITY_DEPOSIT":{
                    res_find = data.find(_data=>_data[unique_key] == item[unique_key]);
                }break;
                default: {
                    res_find = data.find(_data=>_data[item_key] == item[item_key]);
                }break;
            }
            if (res_find == undefined) newItems.push(item);
        }
        this.setState({checkedItems:newItems});
        console.log(newItems);
    }
    allStateClear () {
        var data = this.state.data.map(d => {
            d.checked = false;
            return d;
        });

        this.setState({
            data: data,
            checkedItems:[],
            all_check_status:false
        });
    }

    render() {
        // console.log("render",this.state.all_check_status);
        let search_field_cols = this.search_field_cols();
        let add_field_cols = this.add_field_cols();
        let detail_search_field_btn = this.detail_search_field_btn();
        let detail_search_field_cols = this.detail_search_field_cols();
        let checkbox_field_cols = this.checkbox_field_cols();
        let action_cols = this.action_cols();
        let dialog_defines = this.dialog_defines();
        let message_field_cols = this.message_field_cols();
        const {
            checkbox_field_in_table
        } = this.state
        let data_count = this.state.data_count ? parseInt(this.state.data_count) : 0;
        document.body.style.overflow = "auto";
        return (
            <>
                <div className="content">
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col md="12" className="HEADER">
                                            <Card className="CardBottomNone">
                                                <CardHeader>
                                                    <Row>
                                                        <Col md={this.state.header_md?this.state.header_md:"6"}>
                                                            <TitleWithBadge label={this.state.title} badge={this.state.badge} count={this.props.new_arrivals_count[this.props.badge_key]} onclick={() => { this.setState({ tmp_set: !this.state.tmp_set }); }} />
                                                        </Col>
                                                        {this.state.add_url &&
                                                            <Col md="6">
                                                                <ButtonWithTooltip
                                                                    onclick={() => { this.props.history.push(this.state.add_url) }}
                                                                    class="float-right btn-search btn-facebook"
                                                                    id="tmp"
                                                                    icon="fas fa-plus"
                                                                    label="追加"
                                                                    message="データを追加"
                                                                />
                                                            </Col>
                                                        }
                                                        {add_field_cols}
                                                    </Row>
                                                    <Row>
                                                        <Col md="12" className="margin-auto">
                                                            <Card>
                                                                <CardBody className={"search-box " + (this.state.tmp_set ? 'on' : 'off')}>
                                                                　 {message_field_cols}
                                                                </CardBody>
                                                            </Card>
                                                        </Col>
                                                    </Row>
                                                </CardHeader>
                                                <CardBody>
                                                    <Row>
                                                        {search_field_cols}
                                                        {/*detail_search_field_btn*/}
                                                    </Row>
                                                    <Row>
                                                        <Col md="3">
                                                            <FormGroup>
                                                                <ButtonWithTooltip
                                                                    onclick={() => {this.allStateClear();this.searchWithPageIndex(0);}}
                                                                    class="btn-search"
                                                                    id="tmp"
                                                                    icon="fas fa-search"
                                                                    label="検索"
                                                                    message="検索を開始します。"
                                                                />
                                                            </FormGroup>
                                                        </Col>
                                                    </Row>
                                                    <Row className="textRight">
                                                    {action_cols}
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                    {/*detail_search_field_cols*/}
                                    <CustomTable 
                                        count={data_count}
                                        page={0}
                                        perPage={50}
                                        checkedItems={this.state.checkedItems}
                                        pageIndex={this.state.paging["index"]}
                                        unique_key={this.state.unique_key}
                                        //handlePageUpdate={(pageIndex)=>this.setState({pageIndex})}
                                        checkbox_field_cols={checkbox_field_in_table?<Row>{checkbox_field_cols}</Row>:<></>}
                                        detail_search_field_cols={detail_search_field_cols}
                                        column={this.state.column}
                                        data={this.state.data}
                                        with_all_check={this.state.with_all_check}
                                        detail_search_field={this.state.show_detail_search_field}
                                        defaultSortedColumn={(this.state.defaultSortedColumn&&this.state.defaultSortedColumn.length>0)?this.state.defaultSortedColumn:undefined}
                                        page_id={this.props.page_id}
                                        change_all_check_flg={false}
                                        all_check={this.state.all_check_status}
                                        checkedChangeCallback={(data, targetChecked)=>{

                                            if ( this.state.with_all_check ) { 
                                                var pref_key, item_key;
                                                if ( this.state.unique_key.match("__") ) {
                                                    let keys = this.state.unique_key.split("__");
                                                    pref_key = keys[0];
                                                    item_key = keys[1];
                                                }
                                                else {
                                                    item_key = this.state.unique_key
                                                }
                                                let filter_data = data.filter(function(item,index,array){
                                                    return ( item.checked === targetChecked ); 
                                                });
                                                // console.log(filter_data);
                                                if (targetChecked) {
                                                    this.addCheckedItems(filter_data, pref_key, item_key);
                                                }
                                                else {
                                                    this.removeCheckedItems(filter_data, pref_key, item_key);
                                                }
                                            }
                                            this.setState({data:[...data]})
                                        }}
                                        pageChangeFunc={( customTable,pager) =>{
                                            this.paging( pager );
                                                if (this.state.auto_scroll == true) {
                                                    this.pageChangeHandle(customTable); 
                                                }
                                            }
                                        }
                                        limitChangeFunc={(limit)=>{this.changeForLimit(limit)}}
                                    />
                                    <Row>
                                    {checkbox_field_in_table?"":checkbox_field_cols}
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
                {dialog_defines}
            </>
        );
    }
}
